import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["button"]

  copy() {
    navigator.clipboard
      .writeText(this.textValue)
      .then(() => {
        const icon = this.buttonTarget.querySelector("i")
        const original = [...icon.classList]
        icon.className = "fas fa-check"

        setTimeout(() => {
          icon.className = original.join(" ")
        }, 1500)

        window.dispatchEvent(
          new CustomEvent("toast:show", {
            detail: { message: "Copied to clipboard", type: "success" }
          })
        )
      })
      .catch(() => {
        window.dispatchEvent(
          new CustomEvent("toast:show", {
            detail: { message: "Failed to copy to clipboard", type: "error" }
          })
        )
      })
  }
}
